import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";

import React, { useState } from "react";
import axios from "axios";
import ImageUploading from "react-images-uploading";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button } from "@mui/material";

const TestView = () => {
  const [newUser, setNewUser] = useState({
    name: "",
    birthdate: "",
    photo: "",
  });

  const [propImages, setPropImages] = useState();
  const maxNumber = 2;

  const onPropImagesChange = (imageList, addUpdateIndex) => {
    // data for submit
    // console.log("@@@ Image update");
    // console.log(imageList, addUpdateIndex);
    setPropImages(imageList);

    // // set property data
    // let images = [];
    // imageList.forEach((image) => {
    //   console.log("image.file: ", image.file);
    //   images.append("images", image.file);
    // });

    // console.log("images arr: ", images);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("photo", newUser.photo);
    formData.append("birthdate", newUser.birthdate);
    formData.append("name", newUser.name);

    axios
      .post(`${import.meta.env.VITE_BACKEND_URL}/test/upload-images`, formData)
      .then((res) => {
        // console.log(res);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  const handleChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value });
  };

  const handlePhoto = (e) => {
    // console.log("e.target.files[0]: ", e.target.files[0]);
    setNewUser({ ...newUser, photo: e.target.files[0] });
  };

  const submitImages = () => {
    const formData = new FormData();
    // formData.append("photo", newUser.photo);
    formData.append("birthdate", newUser.birthdate);
    formData.append("name", newUser.name);

    // Append images if any
    if (propImages) {
      propImages.forEach((image) => {
        if (image.file) {
          formData.append("images", image.file);
        }
      });
    }

    axios
      .post(`${import.meta.env.VITE_BACKEND_URL}/test/upload-images`, formData)
      .then((res) => {
        // console.log(res);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  return (
    <>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <input
          type="file"
          accept=".png, .jpg, .jpeg"
          name="photo"
          onChange={handlePhoto}
        />

        <input
          type="text"
          placeholder="name"
          name="name"
          value={newUser.name}
          onChange={handleChange}
        />

        <input
          type="date"
          name="birthdate"
          value={newUser.date}
          onChange={handleChange}
        />

        <input type="submit" />
      </form>
      <div className="form-component">
        <ImageUploading
          multiple
          value={propImages}
          onChange={onPropImagesChange}
          maxNumber={maxNumber}
          dataURLKey="data_url"
        >
          {({
            imageList,
            onImageUpload,
            onImageRemoveAll,
            onImageUpdate,
            onImageRemove,
            isDragging,
            dragProps,
            errors,
          }) => (
            <>
              {errors && (
                <div>
                  {errors.maxNumber && (
                    <span>
                      Number of selected images exceed. You can only upload max.
                      of {maxNumber} images
                    </span>
                  )}
                  {errors.acceptType && (
                    <span>Your selected file type is not allow</span>
                  )}
                  {errors.maxFileSize && (
                    <span>
                      Selected file size exceed. You can only upload a file of
                      max. size {maxFileSize}
                    </span>
                  )}
                  {errors.resolution && (
                    <span>
                      Selected file is not match your desired resolution
                    </span>
                  )}
                </div>
              )}
              <div className="upload__image-wrapper">
                <div
                  {...dragProps}
                  onClick={onImageUpload}
                  className="upload-image-box"
                >
                  {isDragging ? (
                    <div className="upload-image-place">Place here</div>
                  ) : (
                    <div className="upload-image-drag">
                      {/* <FileUploadIcon /> */}
                      <CloudUploadIcon sx={{ fontSize: 86 }} />
                      <div className="upload-image-drag-text">
                        Drag and drop images here to upload!
                      </div>
                      <div className="upload-image-or-text">Or</div>
                      <div className="upload-image-select-btn">
                        Select images to upload
                      </div>
                    </div>
                  )}
                </div>
                &nbsp;
                {imageList && imageList.length > 0 && (
                  <div className="loaded-image-container">
                    <div className="loaded-image-container-header">
                      <div>Uploaded Images</div>
                      <div>
                        <button onClick={onImageRemoveAll}>
                          Remove all images
                        </button>
                      </div>
                    </div>
                    <div className="loaded-image-container-body">
                      {imageList.map((image, index) => (
                        <div key={index} className="image-item">
                          <img src={image["data_url"]} alt="" width="100" />
                          <div className="image-item__btn-wrapper">
                            <button onClick={() => onImageUpdate(index)}>
                              Update
                            </button>
                            <button onClick={() => onImageRemove(index)}>
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </ImageUploading>
        <Button onClick={submitImages} className="fab">
          Submit
        </Button>
      </div>
    </>
  );
};

export default TestView;
